module.exports = __webpack_public_path__ + "img/ic-arrow-link.58d5a92b.svg";